// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2qc96","col":"CardReaderDesc_col__1Fgu0","label":"CardReaderDesc_label__3zUm2"};